import React from 'react';
import { Cell, Layout } from '@wix/design-system';
import { ResizeDetectorWrapper } from '../resize-detector-wrapper';
import { calculateFinalColumns } from './grid.utils';

export interface GridProps {
  dataHook?: string;
  columns: 1 | 2 | 3 | 4;
  minColumns?: 1 | 2 | 3 | 4;
  rows?: number;
  children?: React.ReactNode;
}

export function Grid({
  dataHook,
  columns: requestedColumns,
  minColumns = 1,
  rows,
  children,
}: GridProps) {
  return (
    <ResizeDetectorWrapper dataHook={dataHook}>
      {({ width }) => {
        const noSpaceForTwoColumns = width <= 564;
        const noSpaceForThreeColumns = width <= 870;
        const noSpaceForFourColumns = width <= 1152;

        const finalColumns = calculateFinalColumns({
          requestedColumns,
          noSpaceForThreeColumns,
          noSpaceForTwoColumns,
          noSpaceForFourColumns,
          minColumns,
        });

        const elements = React.Children.toArray(children);

        const elementToRender = rows
          ? elements.slice(0, rows * finalColumns)
          : elements;

        return (
          <Layout gap="24px" rowHeight="1fr">
            {elementToRender.map((element, index) => (
              <Cell span={12 / finalColumns} key={index}>
                {element}
              </Cell>
            ))}
          </Layout>
        );
      }}
    </ResizeDetectorWrapper>
  );
}
